import { render, staticRenderFns } from "./VerticleLayout.vue?vue&type=template&id=44d75840&"
import script from "./VerticleLayout.vue?vue&type=script&lang=js&"
export * from "./VerticleLayout.vue?vue&type=script&lang=js&"
import style0 from "./VerticleLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports